module.exports = __webpack_public_path__ + "static/assets/c983f947192b3825c2e4dfae03d888c5.png";